import React from "react";
import { Redirect } from "react-router-dom";

function LoginFromPasswordReset() {
  return <Redirect to="/" />;
}

export default LoginFromPasswordReset;
